import { parsePhoneNumber } from "libphonenumber-js";
import { addMethod, string as yupString } from "yup";

import { translateWithoutContext } from "@redux/modules/value/translations/translations.helpers";

import { string } from "./general";

// General phone validation

/**
 * Phone validation Rule
 */
addMethod(yupString, "phone", function (required) {
    return this.test("phone", function (value) {
        if (!required && !value) return true;

        let errorMessage = translateWithoutContext(
            "general.form.input.validation.phone.invalid",
        );

        const {
            createError,
            path,
            options: { context: { values: formValues = {}, prefixData } = {} },
        } = this;

        const prefix = formValues[path + "Prefix"];
        const iso = prefixData.find((d: { value: any }) => d.value === prefix);

        let newPhone;
        try {
            newPhone = parsePhoneNumber(`${value!}`, iso.isoCode);
        } catch (_) {
            return createError({ message: errorMessage });
        }

        return newPhone?.isValid() || createError({ message: errorMessage });
    });
});

export const phone = string().nullable(true).required().phone(true);

export const optionalPhone = string().nullable(true).phone(false);
